import React from 'react'
//

export default () => (
    <a href='http://www.freshcode.biz'><strong>freshcode.biz</strong></a>
)



// WEBPACK FOOTER //
// /home/pwl/work/assembla/beatfix.live/www/src/containers/Provider.js